import React, { useState, useContext, useEffect, useRef, useMemo } from 'react'
import UserContext from 'contexts/UserContext'
import { useFormik } from 'formik'
import * as yup from 'yup'
import { UpdateForKyc } from 'helpers/api'
import PersonalInformationContainer from './personalInformationContainer/personalInformationContainer'
import { VerifAccount } from 'requests/transfer'
import { Spinner } from 'utils/loading'
import localforage from 'localforage'
import FlecheRetour from '../assets/arrow-back-navigation.svg'

import ModalFirstOpendTuto from 'rewards/modalFirstOpendTuto'
import ProfileStepOne from './personalInformationContainer/ProfileStepOne'
import ProfileStepTwo from './personalInformationContainer/ProfileStepTwo'
import ProfileStepThree from './personalInformationContainer/ProfileStepThree'
import { useNavigate } from 'react-router-dom'

interface FormValues {
  gender: string
  birthDate: string
  countryOfBirthName: string
  countryOfBirthCode: string
  street: string
  city: string
  zipCode: string
  occupation: string
  transactionPerMonth: string
  numberTransactionsPerMonth: string
}
const Personalinformation: React.FC = () => {
  const minBirthDate = new Date(1910, 0, 1)
  const maxBirthDate = new Date()

  maxBirthDate.setFullYear(maxBirthDate.getFullYear() - 18)
  const { user, setUser } = useContext(UserContext)
  const token = user?.token?.accessToken
  const id = user?.user._id
  const [isOpenfirstModalTutoGame, setIsOpenfirstModalTutoGame] = useState(false)

  const [loading, setLoading] = useState<boolean>(true)

  const [isLink, setIsLink] = useState('')

  const [isVerified, setIsVerified] = useState(false)
  const navigation = useNavigate()
  const fetchDataVerification = async () => {
    const id = user?.user?._id
    const token = user?.token?.accessToken
    try {
      const response = await VerifAccount(id, token)

      if (response?.success) {
        setIsLink(response?.documentUrl)
        setIsVerified(true)
        setLoading(true)
      }
    } catch (error) {
      console.error(error)
    }
  }

  const handleClick = () => {
    if (user) {
      fetchDataVerification()
    }
  }

  const iframeRef = useRef<HTMLIFrameElement>(null)
  const [iframeUrl, setIframeUrl] = useState<string>('')

  useEffect(() => {
    const interval = setInterval(() => {
      const iframe = iframeRef.current
      if (iframe && iframe.contentWindow) {
        const newUrl = iframe.contentWindow.location.href
        if (newUrl !== iframeUrl) {
          setIframeUrl(newUrl)
        }
      }
    }, 5000)
    return () => clearInterval(interval)
  }, [iframeUrl])

  const residentialCountry = user?.user.address.country.name || ''
  const [step, setStep] = useState(0)
  const [isCreating, setIsCreating] = useState(false)
  const initialValues: FormValues = {
    gender: '',
    birthDate: '',
    countryOfBirthName: '',
    countryOfBirthCode: '',
    street: '',
    city: '',
    zipCode: '',
    occupation: '',
    transactionPerMonth: '',
    numberTransactionsPerMonth: '',
  }
  const stepOneSchema = yup.object({
    gender: yup.string().required('Ce champ est requis'),
    birthDate: yup
      .date()
      .typeError('Ce champ est requis')
      .required('Ce champ est requis')
      .max(maxBirthDate, 'Vous devez avoir 18 ans ou plus.')
      .min(minBirthDate, 'Ce champ est requis'),
    countryOfBirthName: yup.string().required('Ce champ est requis'),
  })

  const stepTwoSchema = yup.object({
    street: yup.string().required('Ce champ est requis').min(5, 'Ce champ est requis.'),
    zipCode: yup
      .string()
      .required('Ce champ est requis')
      .min(4, 'Ce champ est requis.')
      .matches(/^[a-zA-Z0-9]+$/, 'Le code postal ne doit contenir que des lettres et des chiffres'),
    city: yup.string().required('Ce champ est requis').min(4, 'Ce champ est requis.'),
  })
  const stepThreeSchema = yup.object({
    occupation: yup.string().required('Ce champ est requis'),
    transactionPerMonth: yup.string().required('Ce champ est requis'),
    numberTransactionsPerMonth: yup.string().required('Ce champ est requis'),
  })
  const validationSchemas = [stepOneSchema, stepTwoSchema, stepThreeSchema]

  const validationSchema = useMemo(() => {
    return validationSchemas[step]
  }, [step])

  const ListeStep = [
    { numStep: 0, isValid: true },
    { numStep: 1, isValid: step >= 1 },
    { numStep: 2, isValid: step >= 2 },
  ]
  const handleSubmit = async (values: FormValues) => {
    if (step < 2) {
      setStep(step + 1)
    }

    if (step === 2 && isStepValid && values) {
      try {
        setIsCreating(true)

        const response = await UpdateForKyc(id, token, values)
        if (response.data.success) {
          if (user) {
            ;(setUser({ token: user.token, success: true, user: response.data.user }),
              localforage.setItem(
                'auth',
                JSON.stringify({ token: user.token, success: true, user: response.data.user }),
              ))
          }
        }
      } catch (error) {
        console.error('Erreur lors de la mise à jour du KYC :', error)
      } finally {
        setIsCreating(false)
        if (!user?.user.game?.isTutoOpened) {
          setIsOpenfirstModalTutoGame(true)
        }
      }
    }
  }

  const formik = useFormik<FormValues>({
    initialValues,
    validationSchema,
    validateOnMount: true,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: handleSubmit,
  })

  const isStepValid = formik.isValid && Object.keys(formik.errors).length === 0
  if (!loading) return <Spinner name="line-scale-pulse-out-rapid" color="#1466ff" />
  return (
    <div className="w-full px-[120px] 2xl:px-[60px] lg:px-[0px] pb-20">
      <div className="flex flex-col justify-center items-center sm:gap-[15px] gap-[24px] w-full ">
        {user?.user?.birthDate ? (
          <div className='w-full'>
            {isLink !== '' && isVerified !== false ? (
              <iframe src={isLink}  className='w-full h-screen 2xl:h-[750px] xl:h-[650px]' />
                
            ) : (
              <PersonalInformationContainer
                handleClick={handleClick}
                isDocumentSent={user?.user?.isDocumentSent ? user?.user?.isDocumentSent : false}
              />
            )}
          </div>
        ) : (
          <form onSubmit={formik.handleSubmit} className="w-full flex flex-col gap-6 mt-[50px] lg:mt-[30px]">
            <div className=" w-full mb-[40px] lg:mb-[0px] flex items-center justify-between ">
              <img className='hidden lg:block cursor-pointer' onClick={() => navigation('/')} src={FlecheRetour} width={20} height={14} alt="Retour à la page précédente" />
              <h1 className='h1 w-full'>Mon profil</h1>
            </div>

            {step === 0 && <ProfileStepOne formik={formik} />}
            {step === 1 && <ProfileStepTwo residentialCountry={residentialCountry} formik={formik} />}
            {step === 2 && <ProfileStepThree formik={formik} />}

            <div className=" flex gap-3 items-center justify-center mt-[30px] 2xl:mt-[10px]">
              {ListeStep.map((_, index) => (
                <div
                  onClick={() => {
                    if (ListeStep[index].isValid) setStep(index)
                  }}
                  key={index}
                  className={`w-[12px] h-[12px] rounded-full cursor-pointer  ${index === step ? 'bg-[#5754E5]' : 'bg-[#D1D1FF]'} `}
                />
              ))}
            </div>
            <button
              // disabled={!formik.isValid}
              className={`${isStepValid ? 'bg-[#5754E5] ' : 'bg-[#D1D1FF] '} text-white w-full rounded-[16px] h-[56px] font-bold `}
              type="submit"
            >
              {step === 2 ? (
                isCreating ? (
                  <svg
                    className="w-6 h-6 mx-auto animate-spin text-white "
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-50"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C6.477 0 2 4.477 2 10h2zm2 5.291A7.971 7.971 0 014 12H2c0 2.21.896 4.209 2.344 5.656l1.656-1.365z"
                    ></path>
                  </svg>
                ) : (
                  'Enregistrer'
                )
              ) : (
                'Suivant'
              )}
            </button>
          </form>
        )}
      </div>
      {isOpenfirstModalTutoGame && (
        <ModalFirstOpendTuto setIsOpenModal={setIsOpenfirstModalTutoGame} isOpenModal={isOpenfirstModalTutoGame} />
      )}
    </div>
  )
}
export default Personalinformation
